export default function digit(value) {
  const nonDigit = /[^0-9]/;
  if (nonDigit.test(value)) {
    return 'must be digit';
  }

  return false;
}
